(function () {
    'use strict';

    angular.module('PWAPoCApp').controller('ErrorController', errorController);

    errorController.$inject = ['$scope', 'translateService' ];

    function errorController($scope, translateService) {
        $scope.errorMessage = '';

        initController();

        function initController() {
            $scope.errorMessage = translateService.translate('errors.browserError');
        }
    }
})();
